export default "__VITE_ASSET__Bu0csI7x__"